import React from 'react';
// import { Rating } from 'react-native-ratings';
import IconComponent from '../../PackageItinerary/components/IconComponent';
// import { callNumber } from '../../../../utils/call';

const InfoPartner = React.memo(({ partner, showPhoneNumber }) => {
  const callPartner = (phoneNumber) => {
    // callNumber(phoneNumber);
  };

  return (
    <div className="p-4 bg-gray-100 rounded-lg shadow-md">
      <div className="flex justify-between mb-4">
        <h2 className="text-lg font-bold">Passenger Details</h2>
      </div>

      <div className="flex items-center gap-4">
        <div>
          {partner?.avatar_url && partner?.avatar_url.trim() !== '' ? (
            <img src={partner.avatar_url} alt="Avatar" className="w-12 h-12 rounded-full" />
          ) : (
            <img src="/path-to-default-avatar.jpg" alt="Default Avatar" className="w-12 h-12 rounded-full" />
          )}

          <div className="flex items-center mt-2">
            {/* <Rating type='star' imageSize={10} readonly={true} startingValue={partner?.rating} ratingCount={5} /> */}
          </div>
        </div>

        <div className="w-3/4">
          <p className="text-xs text-gray-600">Thanks for riding</p>
          <p className="text-lg font-semibold">{partner?.first_name} {partner?.last_name}</p>
        </div>

        {showPhoneNumber && (
          <button className="p-2 bg-blue-500 text-white rounded-full" onClick={() => callPartner(partner?.phone_number)}>
            <IconComponent iconSet="MaterialCommunityIcons" iconName="phone-dial" iconSize={20} />
          </button>
        )}
      </div>
    </div>
  );
});

export default InfoPartner;
